const DOCUMENT = 'ORGANIZATION_';

const actions = {
  ADD_ERROR: DOCUMENT + 'ADD_ERROR',
  ADD_REQUEST: DOCUMENT + 'ADD',
  ADD_SUCCESS: DOCUMENT + 'ADD_SUCCESS',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CREATE: DOCUMENT + 'CREATE',
  EDIT: DOCUMENT + 'EDIT',
  LOAD_ERROR: DOCUMENT + 'LOAD_ERROR',
  LOAD_FORM_DATA_ERROR: DOCUMENT + 'LOAD_FORM_DATA_ERROR',
  LOAD_FORM_DATA_REQUEST: DOCUMENT + 'LOAD_FORM_DATA_REQUEST',
  LOAD_FORM_DATA_SUCCESS: DOCUMENT + 'LOAD_FORM_DATA_SUCCESS',
  LOAD_REQUEST: DOCUMENT + 'LOAD_REQUEST',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  SAVE_ERROR: DOCUMENT + 'SAVE_ERROR',
  SAVE_REQUEST: DOCUMENT + 'SAVE_REQUEST',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  TOUCH: DOCUMENT + 'TOUCH',
  CHANGE_PROPERTIES: DOCUMENT + 'CHANGE_PROPERTIES',

  addOrganizationError: data => ({
    type: actions.ADD_ERROR,
    payload: data,
  }),

  addOrganization: data => ({
    type: actions.ADD_REQUEST,
    payload: data,
  }),

  addOrganizationSuccess: data => ({
    type: actions.ADD_SUCCESS,
    payload: data,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  create: data => ({
    type: actions.CREATE,
    payload: data,
  }),

  edit: data => ({
    type: actions.EDIT,
    payload: data,
  }),

  loadDataError: data => ({
    type: actions.LOAD_ERROR,
    payload: data,
  }),

  loadFormDataError: data => ({
    type: actions.LOAD_FORM_DATA_ERROR,
    payload: data,
  }),

  loadFormDataRequest: data => ({
    type: actions.LOAD_FORM_DATA_REQUEST,
    payload: data,
  }),

  loadFormDataSuccess: data => ({
    type: actions.LOAD_FORM_DATA_SUCCESS,
    payload: data,
  }),

  loadDataRequest: data => ({
    type: actions.LOAD_REQUEST,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  saveOrganizationError: data => ({
    type: actions.SAVE_ERROR,
    payload: data,
  }),

  saveOrganization: data => ({
    type: actions.SAVE_REQUEST,
    payload: data,
  }),

  saveOrganizationSuccess: data => ({
    type: actions.SAVE_SUCCESS,
    payload: data,
  }),

  touch: data => ({
    type: actions.TOUCH,
    payload: data,
  }),

  changeProperties: data => ({
    type: actions.CHANGE_PROPERTIES,
    payload: data,
  }),
};

export default actions;
